
import React from 'react'
import { translate } from 'react-i18next'
import { AppStore, UIStore } from '../../../../stores'
import { Button } from '../../../'
import { capitalize } from '../../../../utils'

/**
 *
 */
const ExportCartConflictsAlert = ({ t, ...props }) => <div className="empty-cart-alert">
  <div className="container">
    <div className="row">
      <p className="p light white s12">Parece que el precio o la disponibilidad de algunos productos de tu carrito han cambiado. Los cambios en el catálogo se aplicarán a su carrito actual.</p>
    </div>
    <div className="row">
      <p className="p regular white s14">Por favor, revisa tu pedido.</p>
      <ul>
        <li><Button placeholder="Aceptar" type="flat" color="blue" onClick={ props.onConfirm } /></li>
      </ul>
    </div>
  </div>
</div>

export default translate(['common'], { wait: false })(ExportCartConflictsAlert)
